import { ShoppingListEntry } from "@/models/ShoppingListEntry";
import { Geolocation, centroid } from "@/models/Geolocation";

class Cluster {
  entries: Array<ShoppingListEntry>;
  constructor(entries: Array<ShoppingListEntry>) {
    this.entries = entries;
  }

  centroidPosition(): Geolocation | null {
    const positions = this.entries
      .filter((entry) => entry.commonShoppingPosition)
      .map((entry) => entry.commonShoppingPosition);
    if (positions.length === 0) {
      return null;
    }
    return centroid(positions);
  }
}

export { Cluster };
